import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { Box, Button, Typography } from '@mui/material';

import { OfferCategory, Reservation, ShippingStatus } from '../graphql/API';
import { ReservationPost } from '../pages/ReservationDetail/ReservationDetail';
import LoadingButton from './Button/LoadingButton';
import { ReservationTimeLeftToPost } from './ReservationTimeLeftToPost';

type Props = {
  reservation: Reservation;
  detailPage?: boolean;
};

export const ReservationPostLink: React.FC<Props> = ({ reservation, detailPage = false }) => {
  const postLinkHandle = React.useCallback(() => {
    window.open(reservation?.postLink || '', '_blank');
  }, [reservation?.postLink]);

  return (
    <Box display={'flex'} alignItems={'center'} gap={'6px'}>
      {!reservation.postOnInstagramStories &&
        !reservation.postOnInstagramStories2x &&
        !reservation.postOnInstagramStories3x &&
        !reservation.postOnInstagramReels &&
        !reservation.postOnTikTokVideo &&
        !reservation.postOnInstagramFeed ? (
        <Typography sx={{ color: '#848484', fontSize: '15px', fontWeight: 500 }}>
          No requirements
        </Typography>
      ) : (
        <>
          {!detailPage && (
            <>
              {reservation.offerCategory !== OfferCategory.product ? (
                <>
                  {reservation.validation === ReservationPost.validationFailed ? (
                    <CloseIcon htmlColor='#DC5564' />
                  ) : reservation.postLink ? (
                    ''
                  ) : (
                    <ReservationTimeLeftToPost data={reservation} />
                  )}
                </>
              ) : (
                <>
                  {reservation.requirementsSubmitted &&
                    reservation.shippingStatus === ShippingStatus.shipped &&
                    reservation.postLink ? (
                    <DoneIcon htmlColor='#37BB90' />
                  ) : reservation.requirementsSubmitted === false &&
                    !reservation.postLink &&
                    reservation.shippingStatus === ShippingStatus.shipped ? (
                    <CloseIcon htmlColor='#DC5564' />
                  ) : (
                    '-'
                  )}
                </>
              )}
            </>
          )}
          {reservation.postLink && detailPage ? (
            <Button
              size='medium'
              variant='outlined'
              sx={{ borderRadius: '7px', px: '18px' }}
              onClick={postLinkHandle}
            >
              Go to post
            </Button>
          ) : reservation.postLink ? (
            <LoadingButton
              variant='text'
              sx={{ textDecoration: 'underline' }}
              onClick={(e) => {
                e.stopPropagation();
                window.open(reservation.postLink || '', '_blank');
              }}
            >
              See post
            </LoadingButton>
          ) : null}
        </>
      )}
    </Box>
  );
};
